import { Link } from 'react-router-dom';
import Navbar from '@/pages/home/components/Navbar';
import FooterSection from '@/pages/home/components/FooterSection';

export default function Glossario() {
  const glossaryTerms = [
    { term: 'Shopping Agent', definition: 'Un servizio o strumento che assiste gli acquirenti nella ricerca, nel confronto e nell\'acquisto di prodotti da marketplace internazionali, fungendo da intermediario informativo.' },
    { term: 'Product Spreadsheet', definition: 'Un foglio di calcolo organizzato che cataloga prodotti per categoria, permettendo una visualizzazione strutturata e un confronto rapido tra diverse opzioni di acquisto.' },
    { term: 'QC Photos', definition: 'Immagini di Controllo Qualità. Fotografie reali del prodotto scattate prima della spedizione per mostrare esattamente cosa riceverà l\'acquirente, senza ritocchi o modifiche.' },
    { term: 'International Shopping', definition: 'L\'attività di acquistare prodotti da marketplace e negozi online situati in paesi diversi dal proprio, spesso per ottenere prezzi migliori o prodotti non disponibili localmente.' },
    { term: 'Chinese Marketplace', definition: 'Piattaforme di e-commerce basate in Cina che offrono una vasta gamma di prodotti a prezzi competitivi, accessibili tramite strumenti come Itaobuy Spreadsheet.' },
    { term: 'Product Research', definition: 'Il processo di analisi e valutazione dei prodotti disponibili sul mercato per identificare le migliori opportunità di acquisto in termini di qualità, prezzo e affidabilità.' },
    { term: 'Online Safety', definition: 'L\'insieme di pratiche, strumenti e precauzioni adottate per proteggere i propri dati personali e finanziari durante gli acquisti su internet.' },
    { term: 'Link Verificato', definition: 'Un collegamento web che è stato controllato e confermato come autentico, sicuro e funzionante prima di essere pubblicato sulla piattaforma Itaobuy Spreadsheet.' },
    { term: 'Marketplace', definition: 'Una piattaforma online che mette in contatto venditori e acquirenti, offrendo una vasta gamma di prodotti in un unico ambiente digitale.' },
    { term: 'Topical Authority', definition: 'L\'autorevolezza che un sito web acquisisce su un argomento specifico grazie alla completezza e alla qualità dei contenuti pubblicati su quel tema.' },
    { term: 'Shopping Internazionale', definition: 'La pratica di acquistare beni e prodotti da venditori situati al di fuori del proprio paese di residenza, sfruttando la globalizzazione del commercio elettronico.' },
    { term: 'Confronto Prezzi', definition: 'L\'attività di analizzare e mettere a confronto i prezzi di prodotti simili da diversi venditori per identificare l\'offerta economicamente più vantaggiosa.' },
    { term: 'Reso', definition: 'La procedura attraverso la quale un acquirente può restituire un prodotto acquistato e ottenere un rimborso, soggetta alle politiche specifiche di ogni venditore.' },
    { term: 'Tracking Spedizione', definition: 'Il sistema di monitoraggio che permette di seguire il percorso di un pacco dalla partenza alla consegna, fornendo aggiornamenti sullo stato della spedizione.' },
    { term: 'Acquisto Impulsivo', definition: 'Un acquisto effettuato senza un\'adeguata pianificazione o valutazione, spesso guidato da emozioni momentanee piuttosto che da una reale necessità.' },
    { term: 'Budget di Spesa', definition: 'Il limite massimo di denaro che un acquirente si prefigge di spendere per i propri acquisti, uno strumento fondamentale per mantenere il controllo finanziario.' },
  ];

  return (
    <>
      <Navbar />
      <main className="pt-24 pb-16">
        <article className="max-w-[960px] mx-auto px-6 md:px-10">

          <script type="application/ld+json">
            {JSON.stringify({
              "@context": "https://schema.org",
              "@type": "Article",
              "headline": "Glossario di Itaobuy Spreadsheet: Tutti i Termini Spiegati",
              "description": "Il glossario completo di Itaobuy Spreadsheet. Scopri il significato di tutti i termini legati allo shopping internazionale, ai marketplace e agli strumenti di acquisto online.",
              "datePublished": "2026-07-14",
              "dateModified": "2026-07-14",
              "author": {
                "@type": "Organization",
                "name": "Itaobuy Spreadsheet Italia",
                "url": "https://itaobuyspread.site/"
              },
              "publisher": {
                "@type": "Organization",
                "name": "Itaobuy Spreadsheet Italia",
                "url": "https://itaobuyspread.site/",
                "logo": {
                  "@type": "ImageObject",
                  "url": "https://static.readdy.ai/image/2df560051ef0cafd8dabf8a049058ba4/62f99c0415358bd5388d5ed1df9ac1ff.jpeg"
                }
              },
              "mainEntityOfPage": {
                "@type": "WebPage",
                "@id": "https://itaobuyspread.site/glossario/"
              },
              "inLanguage": "it-IT"
            })}
          </script>

          <nav className="mb-8" aria-label="Breadcrumb">
            <ol className="flex items-center gap-2 text-xs text-foreground-500">
              <li>
                <Link to="/" className="hover:text-foreground-900 transition-colors">
                  Home
                </Link>
              </li>
              <li><i className="ri-arrow-right-s-line text-xs"></i></li>
              <li className="text-foreground-900 font-medium">Glossario</li>
            </ol>
          </nav>

          <header className="mb-10">
            <span className="inline-flex items-center px-3 py-1 rounded-full bg-accent-100 text-accent-700 text-xs font-medium mb-4 whitespace-nowrap">
              Glossario
            </span>
            <h1 className="font-heading text-3xl md:text-4xl lg:text-5xl font-extrabold text-foreground-950 leading-tight mb-4">
              Glossario di Itaobuy Spreadsheet: Tutti i Termini Spiegati
            </h1>
            <p className="text-foreground-600 leading-relaxed text-sm md:text-base max-w-2xl">
              Il glossario completo di Itaobuy Spreadsheet. Scopri il significato di tutti 
              i termini legati allo shopping internazionale, ai marketplace e agli strumenti 
              di acquisto online.
            </p>
          </header>

          <div className="relative w-full h-[260px] md:h-[340px] rounded-2xl overflow-hidden mb-10">
            <img
              src="https://readdy.ai/api/search-image?query=Clean%20dictionary%20or%20encyclopedia%20concept%20on%20warm%20cream%20desk%2C%20open%20book%20with%20organized%20letter%20tabs%2C%20soft%20natural%20lighting%2C%20minimal%20editorial%20photography%2C%20elegant%20academic%20aesthetic%2C%20neutral%20calming%20tones%2C%20professional%20knowledge%20visualization&width=1400&height=500&seq=glossario-hero-01&orientation=landscape"
              alt="Glossario Itaobuy Spreadsheet"
              title="Glossario dei Termini - Itaobuy Spreadsheet"
              className="w-full h-full object-cover object-top"
            />
          </div>

          <p className="text-foreground-600 leading-relaxed text-sm md:text-base mb-8">
            Ecco il glossario completo dei termini più importanti legati a <strong>Itaobuy Spreadsheet</strong> 
            e allo shopping internazionale. Ogni definizione è stata scritta per essere chiara, 
            precisa e utile sia per i principianti che per gli acquirenti esperti. Per una panoramica 
            completa della piattaforma, visita la nostra <Link to="/" className="text-primary-500 hover:text-primary-600 font-medium underline">homepage</Link>.
          </p>

          <div className="space-y-4">
            {glossaryTerms.map((item) => (
              <div key={item.term} className="bg-background-100 rounded-xl p-5 md:p-6 hover:bg-accent-50 transition-colors">
                <h2 className="font-heading text-lg md:text-xl font-bold text-foreground-950 mb-2">
                  {item.term}
                </h2>
                <p className="text-foreground-600 text-sm md:text-base leading-relaxed">
                  {item.definition}
                </p>
              </div>
            ))}
          </div>

          <div className="mt-12 p-6 md:p-8 bg-accent-50 rounded-2xl border border-accent-200/70">
            <div className="flex flex-col sm:flex-row items-start sm:items-center gap-4 justify-between">
              <div>
                <h3 className="font-heading text-xl font-bold text-foreground-950 mb-1">
                  Ti è Stato Utile il Glossario?
                </h3>
                <p className="text-foreground-600 text-sm">
                  Esplora altre guide o inizia subito i tuoi acquisti.
                </p>
              </div>
              <div className="flex flex-wrap gap-3">
                <Link
                  to="/"
                  className="inline-flex items-center px-5 py-2.5 rounded-full bg-background-50 text-foreground-900 text-sm font-semibold border border-background-200 hover:bg-background-100 transition-colors whitespace-nowrap"
                >
                  <i className="ri-home-4-line mr-2"></i>
                  Torna alla Home
                </Link>
                <a
                  href="https://kaspreadsheet.com"
                  target="_blank"
                  rel="noopener nofollow"
                  className="inline-flex items-center px-5 py-2.5 rounded-full bg-primary-500 text-background-50 text-sm font-semibold hover:bg-primary-600 transition-colors whitespace-nowrap"
                >
                  buy it now
                  <i className="ri-arrow-right-line ml-2"></i>
                </a>
              </div>
            </div>
          </div>
        </article>
      </main>
      <FooterSection />
    </>
  );
}